// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";

const STATUS_COLORS: Record<string, string> = {
  finished: "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
  processing: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  queueing: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  validating:
    "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  uploading: "bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-950 dark:text-cyan-300 dark:border-cyan-900",
  error: "bg-red-100 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900",
  disabled: "bg-zinc-100 text-zinc-700 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-400 dark:border-zinc-800",
};

const FALLBACK = "bg-zinc-100 text-zinc-700 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-400 dark:border-zinc-800";

export function ImportStatusBadge({ status }: { status?: string }) {
  const colorClass = (status && STATUS_COLORS[status]) ?? FALLBACK;
  return (
    <Badge variant="outline" className={`font-normal text-xs ${colorClass}`}>
      {status ?? "unknown"}
    </Badge>
  );
}
